import {GeneralAction} from '../../../@types/actions';
import {DELETE_EXTRA_SETTINGS} from "../../../constants/ExtraConstants";

export const DeleteSettingsAction = (template: string): GeneralAction<string> => ({
    type: DELETE_EXTRA_SETTINGS,
    payload: template
});
